import { apiRequest } from "../../../api/apiRequest";
import { CSV_DATA_FAILURE, CSV_DATA_SUCCESS, REPORT_FAILURE, REPORT_SUCCESS } from "./people.actionTypes";
import {
  DEACTIVATE_USER,
  GET_ADMIN_REPORT,
  GET_ALL_USERS_INFO,
  PATCH_CHANGE_ROLE,
  POST_ADD_USER,
  REACTIVATE_USER,
} from "../../../utils/api";

export const getCSVUploadedData = () => async (dispatch) => {
  const result = await apiRequest("get", GET_ALL_USERS_INFO);

  if (result.success) {
    dispatch({
      type: CSV_DATA_SUCCESS,
      payload: result.data,
    });
    return { success: true, message: result.data };
  } else {
    dispatch({
      type: CSV_DATA_FAILURE,
      payload: {
        message: result.message,
      },
    });
    return { success: false, message: result.message };
  }
};

export const deActivateUser = (payLoad) => async (dispatch) => {
  const result = await apiRequest("patch", DEACTIVATE_USER, payLoad);

  if (result.success) {
    return { success: true };
  } else {
    return { success: false, message: result.message };
  }
};

export const reActivateUser = (payLoad) => async (dispatch) => {
  const result = await apiRequest("patch", REACTIVATE_USER, payLoad);

  if (result.success) {
    return { success: true };
  } else {
    return { success: false, message: result.message };
  }
};

export const addNewUser = (payLoad) => async (dispatch) => {
  const result = await apiRequest("post", POST_ADD_USER, payLoad);

  if (result.success) {
    return { success: true };
  } else {
    return { success: false, message: result.message };
  }
};

export const changeRole = (payLoad, userId) => async (dispatch) => {
  const result = await apiRequest(
    "patch",
    `${PATCH_CHANGE_ROLE}/${userId}`,
    payLoad
  );
  if (result.success) {
    return { success: true };
  } else {
    return { success: false, message: result.message };
  }
};

export const getAdminReport = () => async (dispatch) => {
  const result = await apiRequest("get", GET_ADMIN_REPORT);

  if (result.success) {
    dispatch({
      type: REPORT_SUCCESS,
      payload: result.data,
    });
    return { success: true, message: result.data };
  } else {
    dispatch({
      type: REPORT_FAILURE,
      payload: {
        message: result.message,
      },
    });
    return { success: false, message: result.message };
  }
};